export const FETCHING_CONTEXTS = 'FETCHING_CONTEXTS';
export const FETCH_CONTEXTS_SUCCESS = 'FETCH_CONTEXTS_SUCCESS';
export const FETCHING_USER = 'FETCHING_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAIL = 'FETCH_USER_FAIL';
export const SET_CONTEXT_SUCCESS = 'SET_CONTEXT_SUCCESS';
export const FETCH_USER_CONTEXT_FAILURE = 'FETCH_USER_CONTEXT_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/contexts/ContextsConstants.js